import { BlobProvider } from '@react-pdf/renderer';
import {
  useDateFormatPreference,
  useTimeFormatPreference,
} from '@witmetrics/data-store';
import type { UndecoratedForm } from '@witmetrics/utils';
import type { FieldAnswer } from '@witmetrics/unison-core';
import CustomPdf from '@/components/CustomPdf';
import Dialog from '@/components/Dialog';
import { classes } from './utils';

export type PdfPreviewDialogProps = {
  logo: string;
  form: UndecoratedForm;
  data: FieldAnswer[];
  onClose: () => void;
};

export default function PdfPreviewDialog({
  logo,
  form,
  data,
  onClose,
}: PdfPreviewDialogProps) {
  const dateFormat = useDateFormatPreference();
  const timeFormat = useTimeFormatPreference();
  return (
    <Dialog className={classes.dialog} onClose={onClose}>
      <BlobProvider
        document={
          <CustomPdf
            logoSrc={logo}
            form={form}
            data={data}
            dateFormat={dateFormat}
            timeFormat={timeFormat}
          />
        }>
        {({ url, loading, error }) => {
          if (loading || !url) {
            return <div className={classes.loading}>Generating preview…</div>;
          }
          if (error) {
            return (
              <div className={classes.loading}>Failed to generate preview.</div>
            );
          }
          return <iframe className={classes.iframe} src={url} />;
        }}
      </BlobProvider>
    </Dialog>
  );
}
